import { ServiceModalPageModule } from "./pages/service-modal/service-modal.module";
import { GeolocationService } from "./services/geolocation/geolocation.service";
import { VoucherService } from "./services/voucher/voucher.service";
import { SeoService } from "./services/seo/seo.service";
import { SettingsService } from "./services/settings/settings.service";
import { FcmService } from "./services/fcm/fcm.service";
import { TabsModule } from "ngx-bootstrap/tabs";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { environment } from "../environments/environment";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { FavouritesService } from "./services/favourites/favourites.service";
import { NgbDatepickerModule, NgbDropdownModule, NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { CartService } from "./services/cart/cart.service";
import { ApiServiceProvider } from "./services/api/api.service.provider";
import { EnvironmentServiceProvider } from "./services/environment/environment.service.provider";
import { CategoriesService } from "./services/categories/categories.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInterceptor } from "./interceptors/token.interceptor";
import { HttpClientModule } from '@angular/common/http';
import { AppInitializerService } from "./services/app-initializer/app-initializer.service";
import { IonicStorageModule } from '@ionic/storage-angular';

export function initializeApp(appInitializerService: AppInitializerService) {
  return () => appInitializerService.initializeApp();
}
let imports = [
  BrowserModule,
  HttpClientModule,
  IonicModule.forRoot(),
  AppRoutingModule,
  SharedModule,
  LeafletModule,
  BrowserAnimationsModule,
  NgbDatepickerModule,
  // NgbTypeaheadModule,
  TabsModule.forRoot(),
  NgbDropdownModule,
  ServiceModalPageModule,
  IonicStorageModule.forRoot({      
    name: environment.storage_name ?? 'becreative.bonnie',
  }),
];

const mobileOnlyImports = [];
const webOnlyImports = [
  // AngularFireModule.initializeApp(environment.firebase),
  // AngularFireMessagingModule,
];

if (window["__env"].platform === "mobile") {
  mobileOnlyImports.forEach((val) => {
    imports.push(val);
  });
}

if (window["__env"].platform === "web") {
  webOnlyImports.forEach((val) => {
    imports.push(val);
  });
}

@NgModule({
    declarations: [AppComponent],
    imports: imports,
    providers: [
        
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
          provide: APP_INITIALIZER,
          useFactory: initializeApp,
          deps: [AppInitializerService],
          multi: true,
        },
        EnvironmentServiceProvider,
        ApiServiceProvider,
        LeafletModule,
        CartService,
        FavouritesService,
        SettingsService,
        Title,
        SeoService,
        VoucherService,
        FcmService,
        Geolocation,
        GeolocationService,
        CategoriesService,
        ScreenOrientation,
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
